<div class="row seedfullPage">
  <div class="seedEfulfillmentOuter">

    <div class="seedEfulfillment">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView" [ngClass]="{
    'col-md-9':orderViewtoggle == false,
    'col-md-12':orderViewtoggle == true}">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToDeliveryinstructions()">CPP Delivery Instructions</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item" *ngIf="!isEditMode">
              <span>Create Records</span>
            </li>
            <li class="breadcrumb-item" *ngIf="isEditMode">
              <span>Edit Records</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="row add-products-section">
        <div class="col-md-10"></div>
        <div class="col-md-2">
          <button mat-raised-button class="btns w180" (click)="onAddRecord()" [disabled]="!selectedFormData.accountNumber || accessTypeMode">Add Record</button>
        </div>
      </div>
      <div class="OrderReleaseTop">
        <div *ngIf="error">
          <div class="row">
            <div class="col-md-12">
              <div class="inline-error" *ngIf="error">
                <div class="row">
                  <div class="col-md-12 padding-l0">
                    <ol class="error-list">
                      <li class="justify-content-center align-self-center" *ngFor="let err of errorsList">
                        {{err}}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class=" col-md-6 material-select withBordr cppDeliveryInstructionsAccountName margin-t10 margin-b20">
            <ng-select name="ddlShipTo"
                       [items]="shipToData"
                       [(ngModel)]="selectedFormData.accountNumber"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Account Name"
                       [disabled]="isEditMode"
                       [loading]="shipToDataLoading"
                       (change)="onAccountInputChange()"
                       [closeOnSelect]="true"
                       data-testid="ddl-ship-to-search"
                       [searchFn]="accountSearchFn">
              <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12 mb-2">
                      <div class="mb-0 mt-2" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </div>
                      <div class="mb-0" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div>
                        Account To #: {{item.accountNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-shipto-return-option_'+index">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <!--<ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>-->
            </ng-select>
          </div>

          <div class="col-md-3 deliveryNotes cppDeliveryInstructionsUpdatedBy margin-t30">
            <mat-form-field class="wide100">
              <mat-label>Updated By</mat-label>
              <input matInput type="text" name="updatedBy" class="pb-1"
                     [(ngModel)]="selectedFormData.updatedBy"
                     disabled
                     [maxLength]="60">
            </mat-form-field>
          </div>
          <div class="col-md-3 customerPO cppDeliveryInstructionsUpdatedBy margin-t30">
            <mat-form-field class="wide100">
              <mat-label>Date Updated</mat-label>
              <input matInput type="text" name="dateUpdated" class="pb-1"
                     disabled
                     [(ngModel)]="selectedFormData.dateUpdated"
                     [maxLength]="25">
            </mat-form-field>
          </div>
        </div>
        <!--class="OrderReleaseDetail"-->
        <div *ngIf="deliveryInstructionDS?.data.length != 0" [ngStyle]="deliveryInstructionDS?.data.length > 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}" class="row">
          <div class="col-md-12 productTableOuter cppDeliveryInstructionsCreateEditTable">
            <div class="tableContainer" id="returnRequestView">
              <table mat-table [dataSource]="deliveryInstructionDS" multiTemplateDataRows class="matTables productTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='packagedType'"><th mat-header-cell *matHeaderCellDef class="convFactor text-center">Package Type</th>
            </div>

            <div *ngIf="column=='contactType'"><th mat-header-cell *matHeaderCellDef class="total-units text-center">Contact Type*</th></div>
            <div *ngIf="column=='firstName'"><th mat-header-cell *matHeaderCellDef class="convFactor text-center">First Name*</th></div>
            <div *ngIf="column=='lastName'"><th mat-header-cell *matHeaderCellDef class="hard-soft-release text-center">Last Name*</th></div>
            <div *ngIf="column=='phone'"><th mat-header-cell *matHeaderCellDef class="hard-soft-release text-center">Phone #*</th></div>
            <div *ngIf="column=='deliveryInstructions'"><th mat-header-cell *matHeaderCellDef class="total-units text-center">Delivery Instructions</th></div>
            <div *ngIf="column=='action'"><th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity "></th></div>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='packagedType'" class="productName">
                <div class=" col-md-12 material-select withBordr">
                  <ng-select name="ddlPackagedType"
                             [items]="packagedTypeList"
                             [(ngModel)]="element.packagedType"
                             [clearable]="false"
                             [searchable]="false"
                             class="custom-select-grower grower-add-drop"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [disabled]="element.packagedTypeDisabled"
                             (change)="onGridInputChange(element,'packagedType')"
                             data-testid="ddl-packaged-type-search">
                  </ng-select>
                </div>
              </div>
              <div *ngIf="column=='contactType'" class="available-block text-center contactType">
                <div class="col-md-12 material-select withBordr">
                  <ng-select name="ddlContactType"
                             [items]="contactTypeList"
                             [(ngModel)]="element.contactType"
                             [clearable]="false"
                             [searchable]="false"
                             class="custom-select-grower grower-add-drop"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [disabled]="accessTypeMode"
                             (change)="onGridInputChange(element,'contactType')"
                             data-testid="ddl-contact-type-search">
                  </ng-select>
                </div>
              </div>

              <div *ngIf="column=='firstName'" class="text-center firstName w150">
                <div class="col-md-12 customerPO">
                  <mat-form-field class="wide100">
                    <input matInput type="text" name="firstName" class="pb-1"
                           [(ngModel)]="element.firstName"
                           [maxLength]="25"
                           autocomplete="new-username"
                           [disabled]="accessTypeMode"
                           (change)="onGridInputChange(element,'firstName')">
                  </mat-form-field>
                </div>
              </div>

              <div *ngIf="column=='lastName'" class="text-center firstName w150">
                <div class="col-md-12 customerPO">
                  <mat-form-field class="wide100">
                    <input matInput type="text" name="lastName" class="pb-1"
                           [(ngModel)]="element.lastName"
                           [disabled]="accessTypeMode"
                           autocomplete="new-username"
                           [maxLength]="25"
                           (change)="onGridInputChange(element,'lastName')">
                  </mat-form-field>
                </div>
              </div>

              <div *ngIf="column=='phone'" class="text-center firstName w150">
                <div class="col-md-12 customerPO">
                  <mat-form-field class="wide100">
                    <input matInput type="text" name="phone" class="pb-1"
                           [(ngModel)]="element.phoneNumber"
                           mask="000-000-0000"
                           [disabled]="accessTypeMode"
                           autocomplete="new-username"
                           [maxLength]="25"
                           (change)="onGridInputChange(element,'phoneNumber')">
                  </mat-form-field>
                </div>
              </div>
              <div *ngIf="column=='deliveryInstructions'" class="text-center deliveryInstructions">
                <div class="col-md-12 material-select withBordr">
                  <ng-select name="ddlDeliveryInstructions"
                             [items]="deliveryInstructionsList"
                             [(ngModel)]="element.selectedDeliveryInstructions"
                             [multiple]="true"
                             [clearable]="false"
                             [searchable]="false"
                             class="custom-select-grower grower-add-drop"
                             [virtualScroll]="true"
                             bindLabel="id"
                             bindValue="id"
                             [closeOnSelect]="true"
                             disabled="{{element.isDeliveryInstructionsDisabled}}"
                             (change)="onGridInputChange(element,'deliveryInstructions')"
                             data-testid="ddl-delivery-instructions-search">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <input id="item-{{index}}" type="checkbox" name="item-{{index}}" [ngModel]="item$.selected" /> {{item.value}} ({{item.id}})
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div *ngIf="column=='action' && !accessTypeMode" class="text-center">
                <div class="col-md-12 customerPO">
                  <i title="delete" class="icon-ico-trash handCursor" (click)="deleteProducts(element)"></i>
                </div>
              </div>
            </td>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [hidden]="this.showErrorBlock != true"></tr>
            </table>
          </div>
        </div>
      </div>

      <div>
      </div>
    </div>
  </div>
  <div class="common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>

      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row">
      <div class="col-md-12">
        <button mat-raised-button class="btns" color="primary" [disabled]="!isSubmitEnable || accessTypeMode" (click)="saveDeliveryInstructions()">Save Record</button>
        <button mat-raised-button class="btns" color="primary" (click)="navigateTolandingCppDelivery()">Cancel</button>
      </div>
    </div>
  </div>
</div>
